import { useCallback, useEffect, useState } from 'react'
import { Platform } from 'react-native'
import { getItem, setItem } from '../lib/storage'
import { LEGACY_WEB_TUTORIAL_MODE_KEY, TUTORIAL_MODE_KEY } from '../lib/tutorial'
import { reportError } from '../lib/reporting'

/** Stores the optional contextual-help preference separately for each game. */
export function useGameTutorialMode(gameId: string | undefined) {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    let active = true
    setEnabled(false)
    if (!gameId) return () => { active = false }

    const readPreference = async () => {
      let value = await getItem(TUTORIAL_MODE_KEY(gameId))
      if (value === null && Platform.OS === 'web') {
        value = await getItem(LEGACY_WEB_TUTORIAL_MODE_KEY(gameId))
        if (value !== null) await setItem(TUTORIAL_MODE_KEY(gameId), value)
      }
      return value
    }
    void readPreference()
      .then((value) => {
        if (active) setEnabled(value === 'true')
      })
      .catch((error: unknown) => {
        reportError(error, { tags: { surface: 'game-tutorial', action: 'read-preference' } })
      })

    return () => {
      active = false
    }
  }, [gameId])

  const setTutorialEnabled = useCallback((next: boolean) => {
    setEnabled(next)
    if (!gameId) return
    void setItem(TUTORIAL_MODE_KEY(gameId), String(next)).catch((error: unknown) => {
      reportError(error, { tags: { surface: 'game-tutorial', action: 'write-preference' } })
    })
  }, [gameId])

  return { enabled, setEnabled: setTutorialEnabled }
}
